import { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL; // Use environment variable for API base URL
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user')) || null;
    } catch {
      return null;
    }
  });
  const [token, setToken] = useState(localStorage.getItem('token'));

  // Keep token and user in sync with localStorage
  const saveAuth = (jwt, userData) => {
    localStorage.setItem('token', jwt);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(jwt);
    setUser(userData);
  };

  const login = useCallback(async (email, password) => {
    const res = await axios.post(`${API}/api/auth/login`, {
      email: email.toLowerCase().trim(),
      password,
    });
    const { token: jwt, user: userData } = res.data;
    saveAuth(jwt, userData);
    return userData;
  }, []);

  const loginWithGoogle = useCallback(async (credential) => {
    const res = await axios.post(`${API}/api/auth/google`, { credential });
    const { token: jwt, user: userData } = res.data;
    saveAuth(jwt, userData);
    return userData;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const res = await axios.post(`${API}/api/auth/register`, {
      email: email.toLowerCase().trim(),
      password,
      name,
    });
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{
      user,
      token,
      login,
      loginWithGoogle,
      register,
      logout,
      setUser,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}